// K23: Eigenschaften pro einzelnem Gegner. Im Prototyp werden sie bei jedem Versuch neu gewürfelt
// und vor dem Kampf angezeigt (P4), damit derselbe Kampf nicht immer gleich ausgeht.
import { activeTraits, combatRules, type CombatRules } from '../content/index.ts';
import { createRng } from './rng.ts';
import type { EnemyPlacement } from './types.ts';

/** Jeder Gegner bekommt mit der eingestellten Chance genau eine zufällige Eigenschaft. */
export function rollTraits(enemies: EnemyPlacement[], seed: number, rules: CombatRules = combatRules): EnemyPlacement[] {
  const rng = createRng(seed);
  // K33 (Phase Kern): ausgeblendete Eigenschaften werden nicht gewürfelt
  const traits = activeTraits();
  return enemies.map((e) => {
    const rolled = rng.next() < rules.traitReroll.chance ? [traits[Math.floor(rng.next() * traits.length)]!.id] : [];
    return { ...e, traits: rolled };
  });
}
